import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin((nuxtApp) => {
  // Définir la fonction utilitaire
  const prepareProductDetails = (product, user) => {
    if (!product || !user) {
      throw new Error("Produit ou utilisateur manquant.");
    }

    const price = parseFloat(product.promo_price) || parseFloat(product.price);
    if (!price || isNaN(price)) {
      throw new Error("Prix invalide ou manquant.");
    }

    return {
      productId: product.product_id,
      name: product.title || "Titre non disponible",
      description: product.description || "Description non disponible",
      thumbnail: product.thumbnail || "/images/default-product.png",
      quantity: 1,
      amount: Math.round(price * 100), // Convertir en centimes
      categoryName: product.category_name || "Non spécifié",
      user_id: user.id || null,
      user_email: user.email || "email_utilisateur@inconnu.com",
      slug: product.slug || null,
      author_email: product.author_email || "email_auteur@inconnu.com",
      instructor_email: product.instructor_email || null,
    };
  };

  // Ajouter au contexte Nuxt
  nuxtApp.provide("prepareProductDetails", prepareProductDetails);
});
